import { UserCircleIcon } from '@heroicons/react/24/outline'

export function GuestCount({ count }: { count: number }) {
  return (
    <div className='flex items-center justify-start space-x-1'>
      <UserCircleIcon className='w-5 h-5' />
      <span className='text-base'>
        Up to {count} guest{count > 1 ? 's' : ''}
      </span>
    </div>
  )
}
